import { StyleSheet } from 'react-native';

export default StyleSheet;
